<mat-card class="grid-wrapper mat-elevation-z3">
    <div class="grid-container">
        <div class="grid-wallpaper">
            <img src="{{ componentWallpaper }}" />
            <div class="header-container">
                <div class="header">
                    <h2 class="nomargin">{{ componentHeader }}</h2>
                </div>
            </div>
        </div>
        <div class="grid-header"></div>
        <div class="grid-content">
            <div>
                <a mat-icon-button href="{{ editpath }}" target="_blank">
                    <mat-icon>edit</mat-icon>
                </a>
                <markdown [src]="viewpath"></markdown>
            </div>
        </div>
        <div class="grid-toc"></div>
        <div class="grid-comments">
            <disqus [identifier]="pageId"></disqus>
        </div>
        <div class="grid-footer"></div>
    </div>
</mat-card>
